import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'

import Icon from 'Pods/Shared/Icon/Icon'
import TextareaField from 'Pods/Shared/TextareaField'
import CustomRadioBoxes from 'Pods/Shared/Checkbox/CustomRadioBoxes'
import { RuleRunner, run } from 'Pods/Shared/RuleRunner'
import { required } from 'Pods/Shared/Rules/Rules'

class RateModelButton extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      modalIsOpen: false,
      rated: Boolean(props.rating.score),
      comment: props.rating.comment || '',
      score: props.rating.score || '1',
      showErrors: false,
      disableButton: false,
      validationErrors: {},
    }

    this.onModalOpen = this.onModalOpen.bind(this)
    this.onModalClose = this.onModalClose.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.onSubmitSuccess = this.onSubmitSuccess.bind(this)
    this.onSubmitFailure = this.onSubmitFailure.bind(this)
    this.onScoreChange = this.onScoreChange.bind(this)
  }

  componentDidMount() {
    const { modelId, ratingValue, itemId,  } = this.props

    if ((modelId && ratingValue) && (modelId == itemId)) {
      this.setState({ modalIsOpen: true });
    }
  }

  fieldValidations(score) {
    if (score === '-1') {
      return [
        RuleRunner('comment', 'Comment', required),
      ]
    }
    return [
      RuleRunner('comment', 'Comment'),
    ]
  }

  onModalOpen() {
    this.setState({ modalIsOpen: true })
  }

  onModalClose() {
    this.setState({ modalIsOpen: false })
  }

  handleInputChange(e) {
    const newState = this.state

    newState.comment = e.target.value
    newState.validationErrors = run(newState, this.fieldValidations(this.state.score))

    this.setState(newState)
  }

  onScoreChange(score) {
    const newState = this.state

    newState.score = score
    newState.validationErrors = run(newState, this.fieldValidations(score))

    this.setState(newState)
  }

  handleSubmit(e) {
    e.preventDefault()
    const url = e.target.id === 'rate_and_follow_js' ?
      `/api/internal/items/${this.props.itemId}/rate_and_follow` : `/api/internal/items/${this.props.itemId}/rate`

    this.setState({
      showErrors: true,
      disableButton: true,
      validationErrors: run(this.state, this.fieldValidations(this.state.score)),
    })

    if (Object.getOwnPropertyNames(this.state.validationErrors).length === 0) {
      axios.post(url,
        {
          data: {
            attributes: {
              comment: this.state.comment,
              score: this.state.score,
              item_id: this.props.itemId,
            },
          },
        }).then(this.onSubmitSuccess).catch(this.onSubmitFailure)
    } else {
      this.setState({ disableButton: false })
    }
  }

  onSubmitSuccess(response) {
    this.setState({
      modalIsOpen: false,
      comment: response.data.data.attributes.comment,
      score: String(response.data.data.attributes.score),
      rated: true,
      disableButton: false,
    })
  }

  onSubmitFailure(xhr) {
    App.events.publish('app:notification:flash:error', (xhr.response.data && xhr.response.data.errors[0].detail)
      || 'Something went wrong, please try again')

    this.setState({ disableButton: false })
  }

  errorFor(field) {
    if (this.state.validationErrors) {
      return this.state.validationErrors[field] || ''
    }
  }

  render() {
    const scores = [
      { value: '1', label: 'Positive', icon: ['fas', 'thumbs-up'] },
      { value: '-1', label: 'Negative', icon: ['fas', 'thumbs-down'] },
    ]

    return (
      <Fragment>
        {this.state.rated ? (
          <button className="btn btn-primary" onClick={this.onModalOpen}>
            <Icon type={['far', 'check-circle']} color="white" />
            Reviewed
          </button>
        ) : (
          <button className="btn btn-primary" onClick={this.onModalOpen}>Review</button>
        )}

        <Modal
          isOpen={this.state.modalIsOpen}
          shouldCloseOnOverlayClick
          onRequestClose={this.onModalClose}
          contentLabel="Modal"
          ariaHideApp={false}
          className={{
            base: '',
            afterOpen: 'overlay-modal--container_after-open overlay-modal-container--xs',
            beforeClose: 'overlay-modal--container_before-close',
          }}
          overlayClassName={{
            base: 'overlay-modal--background',
            afterOpen: 'overlay-modal--background_after-open',
            beforeClose: 'overlay-modal--background_before-close',
          }}
        >
          <div className="overlay-modal">
            <button className="btn btn-transparent overlay-modal--close-inner" onClick={this.onModalClose}>
              <Icon type={['fal', 'times']} color="grey-dark" />
            </button>
            <div className="overlay-modal--content overlay-modal--rate-model">
              <div className="l-inner-large">
                <h2 className="heading-24">Review {this.props.itemTitle}</h2>
                <p className="modal-description">
                  Rate fairly and leave constructive feedback about the product and experience with the seller.
                  Note that negative ratings must include an explanation to help us understand any issues with
                  the product and help the seller improve.
                </p>
                <p className="modal-description">
                  Your rating and user name will be publicly visible.
                  You can return and edit this rating at any time in the future.
                </p>
                <label>Leave a rating</label>
                <div className="product-ratings__thumbs">
                  <CustomRadioBoxes
                    options={scores}
                    selectedValue={this.state.score}
                    onChange={this.onScoreChange}
                  />
                </div>
                <TextareaField
                  id="comment"
                  name="comment"
                  label="Write a comment"
                  value={this.state.comment}
                  errorText={this.errorFor('comment')}
                  showError={this.state.showErrors}
                  formClassName="form-group-grey"
                  inputClassName="form-control-grey"
                  onChange={this.handleInputChange}
                  placeholder="Type here..."
                  rows={5}
                />
                <div className="footer u-text-right u-mt10">
                  <button className="btn btn-fat btn-outline-default" onClick={this.onModalClose}>Cancel</button>
                  <button
                    disabled={this.state.disableButton}
                    onClick={this.handleSubmit}
                    className="btn btn-fat btn-outline-default u-ml10"
                  >
                    Rate model
                  </button>
                  {this.state.score === '1' &&
                    <button
                      disabled={this.state.disableButton}
                      onClick={this.handleSubmit}
                      className="btn btn-fat btn-primary u-ml10"
                      id='rate_and_follow_js'
                    >
                      Rate and start following
                    </button>
                  }
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </Fragment>
    )
  }
}

RateModelButton.propTypes = {
  itemId: PropTypes.number.isRequired,
  itemTitle: PropTypes.string.isRequired,
  rating: PropTypes.shape({
    score: PropTypes.string,
    comment: PropTypes.string,
  }).isRequired,
}

export default RateModelButton
